import { DeckType } from '../model/DeckType';
import { doc, runTransaction, Unsubscribe } from "firebase/firestore";
import { db } from "../firebase";
import { Waiting } from "../model/Waiting";
import { User } from '../model/User';

import * as firestoreClient from '../script/firestore-client'
import log from '../script/logger';

const table = 'waiting'

export async function listFromCache(filterOps?: firestoreClient.FilterOption[], sortOps?: firestoreClient.SortOption[], limit?: number) {
  return await firestoreClient.listFromCache(table, filterOps, sortOps, limit) as Waiting[]
}

export function saveWithAssignId(user: User, deckType: DeckType, onlyCloseRate: boolean) {
  const waiting: Waiting = {
    host: Object.assign(user, {deck_type: deckType}),
    date: new Date(),
    only_close_rate: onlyCloseRate
  }
  return firestoreClient.saveWithAssignId(table, waiting)
}

export async function updateGuest(waiting: Waiting, user: User, deckType: DeckType): Promise<Waiting> {
  return await runTransaction(db, async (transaction) => {
    const waitingDocRef = doc(db, 'waiting', waiting.id!)

    log(`find from firestore. table: ${table}, pk: ${waiting.id}`)
    const waitingDoc = await transaction.get(waitingDocRef)

    if (!waitingDoc.exists()) throw new Error('transaction failed');
    if (waitingDoc.data().guest) throw new Error('transaction failed');

    waiting.guest = Object.assign(user, { deck_type: deckType })

    log(`update for firestore. table: ${table}, entity: ${waiting}`)
    transaction.update(waitingDocRef, waiting)

    return waiting
  })
}

export function remove(waitingId: string) {
  firestoreClient.remove(table, [waitingId])
}

export function watch(
  uuid: string,
  cb: (waiting: Waiting) => void
): Unsubscribe {
  return firestoreClient.watch(table, [uuid], data => {
    cb(data as Waiting)
  })
}